<template>
	<div class="yong">
		<back-to></back-to>
		<!-- 搜索 -->
		<section class="yongsearch">
			<div class="yongsearch-left" @click="startCityShow = true">
				<img src="../../assets/sweetour-anew-image_13.png" alt="">
				<p>{{addrText}}</p>
				<i class="arrow-up"></i>
			</div>
			<div class="yongsearch-right">
				<img src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/sweetour-h5_retailstore_search.png"
					alt="">
				<input type="text" class="weui-input" v-model="searchName" placeholder="输入您想要查找的商品名称"
					@keyup.13="searchChange" />
			</div>
		</section>
		<!-- 弹出层 -->
		<section class="modal" @click="startCityShow = false" v-if="startCityShow">
			<div class="modal-main">
				<div class="startCity-box">
					<div class="startCity-list-box">
						<p v-for="(item,index) in startCityList" :key="index" :class="item.value == addrText?'hit':''" @click="depart(item.key,item.value)">{{item.value}}</p>
					</div>
				</div>
			</div>
		</section>
		<!-- tab -->
		<van-tabs class="tabs"  @click="click">
			<van-tab v-for="(item, index) in keepMenuList" :key="index" :title="item.name"></van-tab>
		</van-tabs>
		<!-- 列表 -->
		<van-list class="list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<div class="temp-list-item" v-for="(item,index) in data_product_array" :key="index" @click="$router.push({ path: '/youngDetail',query:{id:item.id}})">
				<div class="temp-list-item-top">
					<span class="temp-item-top_left"><img v-lazy="item.imageUrl" /></span>
					<span class="temp-item-top_right">
						<h2 class="temp-title">{{item.title}}</h2>
						<label class="temp-des" for="">{{item.desc}}</label>
						<p class="temp-num" v-if="item.virtualNumber != 0 && item.virtualNumber != null">
							销量：{{item.virtualNumber}}</p>
					</span>
				</div>
				<div class="temp-list-item-bottom">
					<span class="temp-price" v-if="item.price != null && !item.isFree && item.price != 0">￥
						<p>{{item.price}}</p> 起
					</span>
					<span class="temp-price" v-if="item.price == null || item.isFree || item.price == 0">
						<p>免费</p>
					</span>
				</div>
			</div>
		</van-list>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'yong',
		components: {
			BackTo
		},
		data() {
			return {
				searchName: "",
				data_product_array: [],
				loading: false,
				finished: false,
				page: 1,
				themeId:0,
				addrID: '210100',
				addrText: '沈阳',
				keepMenuList: [],
				// 出发地
				startCityShow: false,
				startCityList: []
			}
		},
		created() {

		},
		mounted() {
			this.cityList()
			this.getTab()
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			cityList(){
				var jsonData = {}
				this.$get(
					this.$apiList + '/NewNearTravel/GetThemeDest?themeId=13', jsonData
				).then(res => {
					this.startCityList = res
				})
			},
			searchChange(){
				this.loading = false
				this.finished = false
				this.page = 1
				this.getList(true)
			},
			click(index){
				this.searchName = ''
				this.loading = false
				this.finished = false
				this.page = 1
				this.themeId = this.keepMenuList[index].id
				this.getList(true)
			},
			depart(addrID,addrText) {
				this.searchName = ''
				this.loading = false
				this.finished = false
				this.addrID =  addrID
				this.addrText =  addrText
				this.page = 1
				this.getList(true)
			},
			getTab() {
				var jsonData = {
					tagName: '周边游',
					id: '6721'
				}
				this.$post(
					this.$connectHttpSweet + '/NewNearTravel/GetNearTravel_BasePage', jsonData
				).then(res => {
					var obj = {
						id: 0,
						name: '全部'
					}
					res.result.tag.menuList.unshift(obj)
					this.keepMenuList = res.result.tag.menuList
				})
			},
			getList(e) {
				var jsonData = {
					tagName: '周边游',
					themeId: this.themeId,
					keyWord: this.searchName,
					pageIndex: this.page,
					isZeroShow: false,
					organizationId: 60,
					city: this.searchName ? 0 : this.addrID,
					xqsnType: Number(this.themeId)
				}
				this.$post(
					this.$apiList + '/NewNearTravel/GetNearTravel_List', jsonData
				).then(res => {
					this.loadShow = false
					if (e) {
						this.data_product_array = res.result.tag.tagProductList
					} else {
						this.data_product_array = this.data_product_array.concat(res.result.tag.tagProductList)
					}
					if (res.result.tag.tagProductList.length < 10) {
						this.finished = true;
					}
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.arrow-up {
		height: 15px;
		width: 15px;
		border-width: 0 3px 3px 0;
		border-style: solid;
		color: #999999;
		/* 根据这个来控制箭头方向 */
		transform: rotate(45deg);
		margin-bottom: 8px;
	}

	.yongsearch {
		width: 100%;
		padding: 20px 28px;
		box-sizing: border-box;
		position: fixed;
		top: @nav-bar-height;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		z-index: 3;
		/* margin-top: @nav-bar-height; */
	}

	.yongsearch-left {
		height: 70px;
		display: flex;
		align-items: center;
		width: 160px;
	}

	.yongsearch-left p {
		font-size: 28px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 90px;
	}

	.yongsearch-left img {
		width: 32px;
		height: 32px;
		margin-right: 12px;
	}

	.yongsearch-right {
		width: 520px;
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		height: 70px;
		font-size: 28px;
		color: #333;
		border-radius: 50px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.yongsearch-right input {
		flex: 1;
		padding-left: 17px;
		background-color: #f5f5f5;
		border: none;
	}

	.yongsearch-right img {
		width: 32px;
		height: 32px;
	}

	.yong .placeholder {
		font-size: 28px;
	}

	.yong .list {
		width: 100%;
		padding: 0 28px;
		box-sizing: border-box;
	}

	.temp-list-item {
		width: 100%;
		margin-top: 20px;
		background-color: #fff;
		border-radius: 24px;
		padding: 20px 26px;
		box-sizing: border-box;
	}

	.temp-list-item-top {
		display: flex;
	}

	.temp-item-top_left,
	.temp-item-top_left img {
		width: 220px;
		height: 220px;
		border-radius: 10px;
	}

	.temp-item-top_right {
		width: 100%;
		padding-left: 19px;
		box-sizing: border-box;
		height: 220px;
		display: flex;
		flex-direction: column;
	}

	.temp-title {
		font-size: 30px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		color: #2b2b2b;
	}

	.temp-des {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		font-size: 26px;
		color: #555;
		margin-top: 14px;
		line-height: 38px;
	}

	.temp-num {
		font-size: 24px;
		color: #a4a4a4;
		margin-top: auto;
	}

	.temp-list-item-bottom {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: 40px;
	}

	.temp-price {
		color: #ff6d00;
		font-size: 22px;
		display: flex;
		align-items: baseline;
	}

	.temp-price p {
		font-size: 40px;
		font-weight: bold;
		padding: 0 4px;
	}

	.yong .tabs {
		margin-top: 110px;
		width: 100%;
	}

	.yong .modal {
		position: fixed;
		top: @nav-bar-height;
		height: calc(100vh - 88px);
		height: 100%;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 113;
		margin-top: 88px;
	}

	.yong .modal-main {
		width: 100%;
		max-height: 100%;
		background: #fff;
		border-bottom-left-radius: 30px;
		border-bottom-right-radius: 30px;
		overflow-y: auto;
		/* padding-bottom: 50px; */
	}

	.yong .startCity-box {
		margin-bottom: 30px;
	}

	.yong .startCity-head {
		height: 80px;
		line-height: 80px;
		padding: 0px 30px;
		font-weight: bold;
		font-size: 28px;
		display: flex;
		justify-content: space-between;
	}

	.yong .startCity-head div {
		font-size: 26px;
		font-weight: 500;
		color: #ff8a00;
	}

	.yong .startCity-list-box {
		width: 100%;
		padding-left: 30px;
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		margin-top: 30px;
	}

	.yong .startCity-list-box p {
		display: block;
		height: 66px;
		line-height: 66px;
		text-align: center;
		width: 216px;
		border-radius: 10px;
		-webkit-border-radius: 10px;
		-moz-border-radius: 10px;
		-ms-border-radius: 10px;
		-o-border-radius: 10px;
		background: #efefef;
		margin-right: 22px;
		padding: 0px 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-sizing: border-box;
	}

	.yong .startCity-list-box text:nth-of-type(3n) {
		margin-right: 0px;
	}

	.yong .startCity-list-box text:nth-of-type(1n + 4) {
		margin-top: 25px;
	}

	.yong .hit {
		color: #ff8a00;
	}
</style>
